import { render, staticRenderFns } from "./ExtendOtherNutrientsRiboflavin.vue?vue&type=template&id=e5d9a326&scoped=true"
import script from "./ExtendOtherNutrientsRiboflavin.vue?vue&type=script&lang=ts"
export * from "./ExtendOtherNutrientsRiboflavin.vue?vue&type=script&lang=ts"
import style0 from "./ExtendOtherNutrientsRiboflavin.vue?vue&type=style&index=0&id=e5d9a326&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5d9a326",
  null
  
)

export default component.exports